/* ───────────────────────────────────────────────────────────
   Lumisca · Theme JS
   - Nav scroll
   - Currency switcher (Shopify Markets)
   - Cart drawer (AJAX)
   - PDP variant + set logic
   - Coming Soon notify form (AJAX)
   ─────────────────────────────────────────────────────────── */
(function(){
  'use strict';

  /* ── NAV SCROLL ── */
  var nav = document.getElementById('nav');
  if (nav) {
    var onScroll = function() {
      nav.classList.toggle('scrolled', window.scrollY > 80);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ── CURRENCY (Shopify Markets) ── */
  document.addEventListener('click', function(e){
    var btn = e.target.closest('.currency-btn');
    if (!btn) return;
    e.preventDefault();
    var country = btn.dataset.country;
    if (!country) return;
    var form = document.createElement('form');
    form.method = 'POST';
    form.action = '/localization';
    form.style.display = 'none';
    form.innerHTML =
      '<input name="_method" value="put">' +
      '<input name="country_code" value="' + country + '">' +
      '<input name="return_to" value="' + window.location.pathname + window.location.search + '">';
    document.body.appendChild(form);
    form.submit();
  });

  /* ── CART DRAWER ── */
  var drawer = document.getElementById('drawer');
  var scrim = document.getElementById('scrim');

  function openDrawer(){
    if (drawer) {
      drawer.classList.add('open');
      drawer.setAttribute('aria-hidden','false');
    }
    if (scrim) scrim.classList.add('open');
    document.body.style.overflow = 'hidden';
    refreshDrawer();
  }
  function closeDrawer(){
    if (drawer) {
      drawer.classList.remove('open');
      drawer.setAttribute('aria-hidden','true');
    }
    if (scrim) scrim.classList.remove('open');
    document.body.style.overflow = '';
  }

  document.addEventListener('click', function(e){
    if (e.target.closest('[data-cart-toggle]')) {
      e.preventDefault();
      openDrawer();
    }
    if (e.target.closest('[data-cart-close]')) {
      e.preventDefault();
      closeDrawer();
    }
  });

  function moneyFmt(cents, currency){
    var amount = cents / 100;
    if (currency === 'INR') {
      return '₹ ' + Math.round(amount).toLocaleString('en-IN');
    }
    return '$ ' + amount.toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2});
  }

  function refreshDrawer(){
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function(r){ return r.json(); })
      .then(function(cart){ renderDrawer(cart); })
      .catch(function(err){ console.warn('Cart fetch failed', err); });
  }

  function renderDrawer(cart){
    var body = document.querySelector('[data-drawer-body]');
    var footer = document.getElementById('drawer-footer');
    var total = document.querySelector('[data-drawer-total]');
    var bagNum = document.getElementById('bag-num');
    var bagWrap = document.getElementById('bag-count-nav');

    if (bagNum) bagNum.textContent = cart.item_count;
    if (bagWrap) bagWrap.style.display = cart.item_count > 0 ? '' : 'none';

    if (!body) return;
    if (cart.item_count === 0) {
      body.innerHTML = '<p class="drawer-empty">Your bag is quiet.</p>';
      if (footer) footer.style.display = 'none';
      return;
    }
    if (footer) footer.style.display = '';
    if (total) total.textContent = moneyFmt(cart.total_price, cart.currency);

    var rows = cart.items.map(function(item){
      var img = item.image
        ? '<img src="' + item.image.replace(/\.([^.]+)$/, '_200x.$1') + '" alt="" loading="lazy">'
        : '<div style="aspect-ratio:3/4;background:var(--bg-warm);"></div>';
      var opt = item.variant_title && item.variant_title !== 'Default Title'
        ? '<p class="cart-line-opt">' + escapeHtml(item.variant_title) + '</p>' : '';
      return (
        '<div class="cart-line" data-cart-line data-key="' + item.key + '">' +
          img +
          '<div>' +
            '<a href="' + item.url + '" class="cart-line-name">' + escapeHtml(item.product_title) + '</a>' +
            opt +
            '<p class="cart-line-price">' + moneyFmt(item.final_price, cart.currency) + '</p>' +
            '<p class="cart-line-qty">Qty ' + item.quantity + '</p>' +
            '<button type="button" class="cart-line-remove" data-cart-remove>Remove</button>' +
          '</div>' +
          '<div class="cart-line-price" style="text-align:right;">' + moneyFmt(item.final_line_price, cart.currency) + '</div>' +
        '</div>'
      );
    }).join('');
    body.innerHTML = rows;
  }

  function escapeHtml(s){
    return String(s).replace(/[&<>"']/g, function(c){
      return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];
    });
  }

  /* Remove line item */
  document.addEventListener('click', function(e){
    var btn = e.target.closest('[data-cart-remove]');
    if (!btn) return;
    e.preventDefault();
    var row = btn.closest('[data-cart-line]');
    if (!row) return;
    var key = row.dataset.key;
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    })
    .then(function(r){ return r.json(); })
    .then(function(cart){ renderDrawer(cart); })
    .catch(function(err){ console.warn('Remove failed', err); });
  });

  /* ── PDP ── */
  var pdpForm = document.querySelector('[data-pdp-form]');

  if (pdpForm) {
    var variants = [];
    try { variants = JSON.parse(pdpForm.dataset.variants || '[]'); } catch(e) {}
    var isSet = pdpForm.dataset.isSet === 'true';
    var firstSetBtn = pdpForm.querySelector('[data-set-option]');
    var selectedSet = firstSetBtn ? firstSetBtn.dataset.setOption : null;
    var selectedSize = null;

    // Initialize size from active button
    var initSize = pdpForm.querySelector('.pdp-size.active');
    if (initSize) selectedSize = initSize.dataset.size;

    function findVariant() {
      return variants.find(function(v){
        if (isSet) {
          var matchesSet = v.option1 === selectedSet || (v.options && v.options[0] === selectedSet);
          var matchesSize = !selectedSize || v.option2 === selectedSize || (v.options && v.options[1] === selectedSize);
          return matchesSet && matchesSize;
        }
        if (selectedSize) {
          return v.option1 === selectedSize || (v.options && v.options[0] === selectedSize);
        }
        return v.available;
      }) || variants[0];
    }

    function updateVariant() {
      var v = findVariant();
      if (!v) return;
      var hidden = pdpForm.querySelector('[data-variant-id]');
      if (hidden) hidden.value = v.id;
      var priceEl = document.querySelector('[data-pdp-price]');
      if (priceEl) priceEl.textContent = formatPrice(v.price);
      var addBtn = pdpForm.querySelector('.pdp-add');
      if (addBtn) {
        if (v.available) {
          addBtn.removeAttribute('disabled');
          addBtn.textContent = 'Add to Bag';
        } else {
          addBtn.setAttribute('disabled', 'disabled');
          addBtn.textContent = 'Sold Out';
        }
      }
    }

    function formatPrice(cents){
      var currency = pdpForm.dataset.currency || 'INR';
      return moneyFmt(cents, currency);
    }

    // Set option click
    pdpForm.addEventListener('click', function(e){
      var setBtn = e.target.closest('[data-set-option]');
      if (setBtn) {
        e.preventDefault();
        pdpForm.querySelectorAll('[data-set-option]').forEach(function(b){ b.classList.remove('active'); });
        setBtn.classList.add('active');
        selectedSet = setBtn.dataset.setOption;
        updateVariant();
        return;
      }
      var sizeBtn = e.target.closest('[data-size]');
      if (sizeBtn) {
        e.preventDefault();
        pdpForm.querySelectorAll('[data-size]').forEach(function(b){ b.classList.remove('active'); });
        sizeBtn.classList.add('active');
        selectedSize = sizeBtn.dataset.size;
        updateVariant();
        return;
      }
    });

    // Add to cart submission
    pdpForm.addEventListener('submit', function(e){
      e.preventDefault();
      var v = findVariant();
      if (!v || !v.available) return;
      var fd = new FormData();
      fd.append('id', v.id);
      fd.append('quantity', '1');
      var btn = pdpForm.querySelector('.pdp-add');
      var origText = btn ? btn.textContent : '';
      if (btn) btn.textContent = 'Adding...';
      fetch('/cart/add.js', {
        method: 'POST',
        body: fd,
        headers: { 'Accept': 'application/json' }
      })
      .then(function(r){ return r.json(); })
      .then(function(){
        if (btn) btn.textContent = origText;
        openDrawer();
      })
      .catch(function(err){
        console.warn('Add failed', err);
        if (btn) btn.textContent = origText;
      });
    });

    // PDP gallery thumb swap
    document.querySelectorAll('[data-pdp-thumb]').forEach(function(thumb){
      thumb.addEventListener('click', function(){
        document.querySelectorAll('[data-pdp-thumb]').forEach(function(t){ t.classList.remove('active'); });
        thumb.classList.add('active');
        var main = document.querySelector('[data-pdp-main]');
        if (main && thumb.dataset.img) {
          main.style.backgroundImage = "url('" + thumb.dataset.img + "')";
        }
      });
    });
  }

  /* ── Coming Soon Notify (AJAX, optional) ── */
  var csForm = document.getElementById('cs-notify-form');
  if (csForm) {
    csForm.addEventListener('submit', function(e){
      e.preventDefault();
      var fd = new FormData(csForm);
      fetch('/contact#contact_form', {
        method: 'POST',
        body: fd,
        headers: { 'Accept': 'text/html' }
      })
      .then(function(){
        csForm.innerHTML = '<span class="cs-success">Thank you — we will be in touch when it lands.</span>';
      })
      .catch(function(){
        csForm.submit();
      });
    });
  }

  /* ── Reveal animations on scroll ── */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if (entry.isIntersecting) {
          entry.target.classList.add('revealed');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });
    document.querySelectorAll('.statement, .pillars, .credit-strip, .new-in-section, .ig-section, .fs-block, .fabric-macro, .fp-header, .ct-body').forEach(function(el){
      io.observe(el);
    });
  }

})();
